import * as React from 'react';
import './Validated.css';

interface ValidatedProps {
  message: string | undefined;
  /** エラーメッセージの要素に付けるid。入力欄のaria-describedbyから参照するときに渡す */
  messageId?: string;
}

/**
 * 子要素の入力欄に検証エラーを表示する。
 * エラーがあるときは、直下の入力欄の枠を危険色にし、その下に危険色の文字でメッセージを出す。
 */
export const Validated: React.FC<ValidatedProps> = function (props) {
  if (!props.message) {
    return (
      <div className="Validated">
        <div className="Validated-field">{props.children}</div>
      </div>
    );
  }

  return (
    <div className="Validated Validated-invalid">
      <div className="Validated-field">{props.children}</div>
      <p className="Validated-message" id={props.messageId} role="alert">
        {props.message}
      </p>
    </div>
  );
};
